
export enum RoundingType {
    NoRounding = 10,
    Round = 1,
    Floor = 2,
    Ceiling = 3,
    CarryRemainder = 4
}